module.exports = __webpack_public_path__ + "img/2.065483e6.png";